function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "ymca-text-logo"
}, "YMCA Text Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "6.94 0.11 4.26 3.89 4.26 7 2.87 7 2.87 3.87 0.2 0.11 1.86 0.11 3.56 2.73 5.29 0.11 6.94 0.11"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "17.38 7 16.88 2.73 15.2 6.22 14.11 6.22 12.41 2.73 11.91 7 10.49 7 11.34 0.11 12.52 0.11 14.65 4.63 16.76 0.11 17.96 0.11 18.8 7 17.38 7"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23,3.55A3.5,3.5,0,0,1,26.49,0,3.42,3.42,0,0,1,29.3,1.46l-1.06.77a2,2,0,0,0-1.7-.89,2.14,2.14,0,0,0-2.16,2.21,2.15,2.15,0,0,0,2.15,2.23,2,2,0,0,0,1.71-.9l1.06.78a3.45,3.45,0,0,1-2.81,1.43A3.51,3.51,0,0,1,23,3.55Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.92.11h-1.5L32.85,7h1.48l.55-1.65h2.58L38,7h1.46Zm-1.63,4,.87-2.59L37,4.14Z"
});

var SvgYmcaTextLogo = function SvgYmcaTextLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "ymca-text-logo",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 40 8",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "ymca-text-logo"
  }, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYmcaTextLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ymca-text-logo.17a7e2e0.svg";
export { ForwardRef as ReactComponent };